// Copyright 2021-2024 Zenauth Ltd.
import { Message, proto3 } from "@bufbuild/protobuf";
/**
 * Used client side in the Remix app
 *
 * @generated from enum spitfire.analytics.v1.PageCategory
 */
export var PageCategory;
(function (PageCategory) {
    /**
     * @generated from enum value: PAGE_CATEGORY_UNSPECIFIED = 0;
     */
    PageCategory[PageCategory["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: PAGE_CATEGORY_ERROR = 1;
     */
    PageCategory[PageCategory["ERROR"] = 1] = "ERROR";
    /**
     * @generated from enum value: PAGE_CATEGORY_LANDING = 2;
     */
    PageCategory[PageCategory["LANDING"] = 2] = "LANDING";
    /**
     * @generated from enum value: PAGE_CATEGORY_APP_LANDING = 3;
     */
    PageCategory[PageCategory["APP_LANDING"] = 3] = "APP_LANDING";
    /**
     * @generated from enum value: PAGE_CATEGORY_ORGANIZATION_CREATE = 4;
     */
    PageCategory[PageCategory["ORGANIZATION_CREATE"] = 4] = "ORGANIZATION_CREATE";
    /**
     * @generated from enum value: PAGE_CATEGORY_ORGANIZATION_SETTINGS = 5;
     */
    PageCategory[PageCategory["ORGANIZATION_SETTINGS"] = 5] = "ORGANIZATION_SETTINGS";
    /**
     * @generated from enum value: PAGE_CATEGORY_ORGANIZATION_BILLING = 6;
     */
    PageCategory[PageCategory["ORGANIZATION_BILLING"] = 6] = "ORGANIZATION_BILLING";
    /**
     * @generated from enum value: PAGE_CATEGORY_ORGANIZATION_MEMBERS = 7;
     */
    PageCategory[PageCategory["ORGANIZATION_MEMBERS"] = 7] = "ORGANIZATION_MEMBERS";
    /**
     * @generated from enum value: PAGE_CATEGORY_ORGANIZATION_MEMBERS_ADD = 8;
     */
    PageCategory[PageCategory["ORGANIZATION_MEMBERS_ADD"] = 8] = "ORGANIZATION_MEMBERS_ADD";
    /**
     * @generated from enum value: PAGE_CATEGORY_WORKSPACE_CREATE = 9;
     */
    PageCategory[PageCategory["WORKSPACE_CREATE"] = 9] = "WORKSPACE_CREATE";
    /**
     * @generated from enum value: PAGE_CATEGORY_WORKSPACE_HOME = 10;
     */
    PageCategory[PageCategory["WORKSPACE_HOME"] = 10] = "WORKSPACE_HOME";
    /**
     * @generated from enum value: PAGE_CATEGORY_WORKSPACE_BUILDS = 11;
     */
    PageCategory[PageCategory["WORKSPACE_BUILDS"] = 11] = "WORKSPACE_BUILDS";
    /**
     * @generated from enum value: PAGE_CATEGORY_WORKSPACE_BUILDS_DETAIL = 12;
     */
    PageCategory[PageCategory["WORKSPACE_BUILDS_DETAIL"] = 12] = "WORKSPACE_BUILDS_DETAIL";
    /**
     * @generated from enum value: PAGE_CATEGORY_WORKSPACE_DEPLOYMENTS = 13;
     */
    PageCategory[PageCategory["WORKSPACE_DEPLOYMENTS"] = 13] = "WORKSPACE_DEPLOYMENTS";
    /**
     * @generated from enum value: PAGE_CATEGORY_WORKSPACE_DECISION_POINTS = 14;
     */
    PageCategory[PageCategory["WORKSPACE_DECISION_POINTS"] = 14] = "WORKSPACE_DECISION_POINTS";
    /**
     * @generated from enum value: PAGE_CATEGORY_WORKSPACE_SETTINGS = 15;
     */
    PageCategory[PageCategory["WORKSPACE_SETTINGS"] = 15] = "WORKSPACE_SETTINGS";
    /**
     * @generated from enum value: PAGE_CATEGORY_WORKSPACE_API_KEY_CREATE = 16;
     */
    PageCategory[PageCategory["WORKSPACE_API_KEY_CREATE"] = 16] = "WORKSPACE_API_KEY_CREATE";
    /**
     * @generated from enum value: PAGE_CATEGORY_ONBOARDING = 17;
     */
    PageCategory[PageCategory["ONBOARDING"] = 17] = "ONBOARDING";
    /**
     * @generated from enum value: PAGE_CATEGORY_LEGAL = 18;
     */
    PageCategory[PageCategory["LEGAL"] = 18] = "LEGAL";
    /**
     * @generated from enum value: PAGE_CATEGORY_WORKSPACE_ISSUES = 19;
     */
    PageCategory[PageCategory["WORKSPACE_ISSUES"] = 19] = "WORKSPACE_ISSUES";
    /**
     * @generated from enum value: PAGE_CATEGORY_ORGANIZATION_PLAYGROUNDS = 20;
     */
    PageCategory[PageCategory["ORGANIZATION_PLAYGROUNDS"] = 20] = "ORGANIZATION_PLAYGROUNDS";
    /**
     * @generated from enum value: PAGE_CATEGORY_ORGANIZATION_PLAYGROUNDS_INSTANCE = 21;
     */
    PageCategory[PageCategory["ORGANIZATION_PLAYGROUNDS_INSTANCE"] = 21] = "ORGANIZATION_PLAYGROUNDS_INSTANCE";
    /**
     * @generated from enum value: PAGE_CATEGORY_ORGANIZATION_WORKSPACES = 22;
     */
    PageCategory[PageCategory["ORGANIZATION_WORKSPACES"] = 22] = "ORGANIZATION_WORKSPACES";
    /**
     * @generated from enum value: PAGE_CATEGORY_ORGANIZATION_HOME = 23;
     */
    PageCategory[PageCategory["ORGANIZATION_HOME"] = 23] = "ORGANIZATION_HOME";
})(PageCategory || (PageCategory = {}));
// Retrieve enum metadata with: proto3.getEnumType(PageCategory)
proto3.util.setEnumType(PageCategory, "spitfire.analytics.v1.PageCategory", [
    { no: 0, name: "PAGE_CATEGORY_UNSPECIFIED" },
    { no: 1, name: "PAGE_CATEGORY_ERROR" },
    { no: 2, name: "PAGE_CATEGORY_LANDING" },
    { no: 3, name: "PAGE_CATEGORY_APP_LANDING" },
    { no: 4, name: "PAGE_CATEGORY_ORGANIZATION_CREATE" },
    { no: 5, name: "PAGE_CATEGORY_ORGANIZATION_SETTINGS" },
    { no: 6, name: "PAGE_CATEGORY_ORGANIZATION_BILLING" },
    { no: 7, name: "PAGE_CATEGORY_ORGANIZATION_MEMBERS" },
    { no: 8, name: "PAGE_CATEGORY_ORGANIZATION_MEMBERS_ADD" },
    { no: 9, name: "PAGE_CATEGORY_WORKSPACE_CREATE" },
    { no: 10, name: "PAGE_CATEGORY_WORKSPACE_HOME" },
    { no: 11, name: "PAGE_CATEGORY_WORKSPACE_BUILDS" },
    { no: 12, name: "PAGE_CATEGORY_WORKSPACE_BUILDS_DETAIL" },
    { no: 13, name: "PAGE_CATEGORY_WORKSPACE_DEPLOYMENTS" },
    { no: 14, name: "PAGE_CATEGORY_WORKSPACE_DECISION_POINTS" },
    { no: 15, name: "PAGE_CATEGORY_WORKSPACE_SETTINGS" },
    { no: 16, name: "PAGE_CATEGORY_WORKSPACE_API_KEY_CREATE" },
    { no: 17, name: "PAGE_CATEGORY_ONBOARDING" },
    { no: 18, name: "PAGE_CATEGORY_LEGAL" },
    { no: 19, name: "PAGE_CATEGORY_WORKSPACE_ISSUES" },
    { no: 20, name: "PAGE_CATEGORY_ORGANIZATION_PLAYGROUNDS" },
    { no: 21, name: "PAGE_CATEGORY_ORGANIZATION_PLAYGROUNDS_INSTANCE" },
    { no: 22, name: "PAGE_CATEGORY_ORGANIZATION_WORKSPACES" },
    { no: 23, name: "PAGE_CATEGORY_ORGANIZATION_HOME" },
]);
/**
 * @generated from message spitfire.analytics.v1.Identify
 */
export class Identify extends Message {
    /**
     * @generated from field: string user_id = 1;
     */
    userId = "";
    /**
     * @generated from field: string email = 2;
     */
    email = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "spitfire.analytics.v1.Identify";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new Identify().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Identify().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Identify().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Identify, a, b);
    }
}
/**
 * @generated from message spitfire.analytics.v1.Page
 */
export class Page extends Message {
    /**
     * @generated from field: spitfire.analytics.v1.PageCategory category = 1;
     */
    category = PageCategory.UNSPECIFIED;
    /**
     * @generated from field: string name = 2;
     */
    name = "";
    /**
     * @generated from field: string organization_id = 3;
     */
    organizationId = "";
    /**
     * @generated from field: string workspace_id = 4;
     */
    workspaceId = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "spitfire.analytics.v1.Page";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "category", kind: "enum", T: proto3.getEnumType(PageCategory) },
        { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new Page().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Page().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Page().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Page, a, b);
    }
}
//# sourceMappingURL=analytics_pb.js.map